// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.delete-dialog-container {
  width: 319px;
  height: 199px;
  opacity: 1;
  position: fixed;
  left: calc(50% - 160px);
  top: calc(50% - 100px);
  z-index: 10;
  animation: popup 0.1s ease-in-out 0s 1;
  border-radius: 5px;
}
.delete-dialog-title {
  width: 120px;
  height: 25px;
  font-size: 18px;
  opacity: 1;
  width: 100%;
  text-align: center;
  position: absolute;
  top: 22px;
  font-weight: 500;
}

.delete-dialog-book-title {
  position: absolute;
  top: 60px;
  width: calc(100% - 20px);
  line-height: 25px;
  font-size: 18px;
  opacity: 1;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  white-space: normal;
  word-break: keep-all;
  overflow: hidden;
  padding-left: 10px;
  padding-right: 10px;
}
.delete-dialog-other-option {
  font-size: 13px;
  text-align: center;
  line-height: 18px;
  opacity: 1;
  position: absolute;
  top: 106px;
  padding-left: 5px;
  padding-right: 5px;
  width: calc(100% - 10px);
  /* margin-left: 25px; */
}

.delete-dialog-uncheck-icon {
  width: 12px;
  height: 12px;
  border-radius: 5px;
  opacity: 1;
  position: absolute;
  top: 106px;
  right: 25px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/dialogs/deleteDialog/deleteDialog.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,eAAe;EACf,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,sCAAsC;EACtC,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,eAAe;AACjB","sourcesContent":[".delete-dialog-container {\n  width: 319px;\n  height: 199px;\n  opacity: 1;\n  position: fixed;\n  left: calc(50% - 160px);\n  top: calc(50% - 100px);\n  z-index: 10;\n  animation: popup 0.1s ease-in-out 0s 1;\n  border-radius: 5px;\n}\n.delete-dialog-title {\n  width: 120px;\n  height: 25px;\n  font-size: 18px;\n  opacity: 1;\n  width: 100%;\n  text-align: center;\n  position: absolute;\n  top: 22px;\n  font-weight: 500;\n}\n\n.delete-dialog-book-title {\n  position: absolute;\n  top: 60px;\n  width: calc(100% - 20px);\n  line-height: 25px;\n  font-size: 18px;\n  opacity: 1;\n  text-align: center;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 1;\n  white-space: normal;\n  word-break: keep-all;\n  overflow: hidden;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.delete-dialog-other-option {\n  font-size: 13px;\n  text-align: center;\n  line-height: 18px;\n  opacity: 1;\n  position: absolute;\n  top: 106px;\n  padding-left: 5px;\n  padding-right: 5px;\n  width: calc(100% - 10px);\n  /* margin-left: 25px; */\n}\n\n.delete-dialog-uncheck-icon {\n  width: 12px;\n  height: 12px;\n  border-radius: 5px;\n  opacity: 1;\n  position: absolute;\n  top: 106px;\n  right: 25px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
